import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames";
import { isGamesTheme } from "@utils";
import { useRootAppStore } from "@hooks";
import { WalletItemProps } from "./types";

export default observer(function AccountTypeSelector(props: WalletItemProps) {
	const { isInMenu, wallet, numberOfWallets } = props;
	const rootStore = useRootAppStore();

	if (isGamesTheme()) {
		return null;
	}

	if (
		numberOfWallets == 1 ||
		("canBeSelected" in wallet && wallet.canBeSelected == false) ||
		!isInMenu
	) {
		return (
			<input
				id={`${wallet.id}${isInMenu ? "-menu" : ""}`}
				name={isInMenu ? "accountSelector-menu" : "accountSelector"}
				className={classnames("wallet__radio input--radio__box", {
					"input--radio--sml__box is-hidden": isInMenu,
					"wallet--sml__radio input--radio--tny__box is-disabled":
						!isInMenu,
				})}
				type="radio"
				disabled={true}
			/>
		);
	}

	return (
		<input
			id={`${wallet.id}${isInMenu ? "-menu" : ""}`}
			name={isInMenu ? "accountSelector-menu" : "accountSelector"}
			className={classnames("input--radio__box", {
				"input--radio--sml__box": isInMenu,
				"input--radio--tny__box": !isInMenu,
			})}
			type="radio"
			value={wallet.id}
			data-id={wallet.id}
			onChange={() => {
				rootStore.userAuthStore.setActiveWalletId(wallet.id);
                rootStore.betSlipStore.fetchFreeBets(true);

				if (wallet.abrv === "sport-betting-account-shop-online") {
					rootStore.waitingPeriodStore.hidePopup();
				}
			}}
			checked={rootStore.userAuthStore.activeWalletId === wallet.id}
		/>
	);
});
